import { render, staticRenderFns } from "./AddRecordModal.vue?vue&type=template&id=1c1cf16d&"
import script from "./AddRecordModal.vue?vue&type=script&lang=js&"
export * from "./AddRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1cf16d')) {
      api.createRecord('1c1cf16d', component.options)
    } else {
      api.reload('1c1cf16d', component.options)
    }
    module.hot.accept("./AddRecordModal.vue?vue&type=template&id=1c1cf16d&", function () {
      api.rerender('1c1cf16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/AddRecordModal.vue"
export default component.exports